<div
  class="notification-sheet"
  (touchstart)="onTouchStart($event)"
  (touchmove)="onTouchMove($event)"
  (touchend)="onTouchEnd()"
>
  <div class="notification-sheet__handle"></div>

  <div #sheetBody class="notification-sheet__body">
    <header class="notification-sheet__header">
      <div class="notification-sheet__meta">
        <span class="notification-sheet__category">
          {{ data?.category || data?.title || 'News' }}
        </span>
        <span class="notification-sheet__dot">•</span>
        <span class="notification-sheet__date">
          {{ data?.created_at || data?.date || 'Yesterday' }}
        </span>
      </div>
    </header>

    @if (imageUrlSafe) {
      <img
        class="notification-sheet__image"
        [src]="imageUrlSafe"
        [alt]="data?.title || 'Notification image'"
      />
    }

    <section class="notification-sheet__content">
      <div
        class="notification-sheet__text"
        [innerHTML]="sanitizedBody"
      ></div>

      @if (data?.details) {
        <p class="notification-sheet__details">
          {{ data.details }}
        </p>
      }
    </section>
  </div>
</div>
